import "regenerator-runtime/runtime";
import _asyncToGenerator from "/app/node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator.js";
import router from "./router";
import store from "./store";
import NProgress from "nprogress"; // progress bar
import "nprogress/nprogress.css"; // progress bar style
import { getToken, removeToken } from "@/utils/auth"; // get token from cookie
import { getInfo } from "@/api/user";
import getPageTitle from "@/utils/get-page-title";
import { codeEnum } from "./enum";
NProgress.configure({
  showSpinner: false
}); // NProgress Configuration

var whiteList = ["/login", "/404", "/register", "/personRegister", "/personResetPassword", "/success", "/404", "/query"]; // no redirect whitelist

router.beforeEach(/*#__PURE__*/function () {
  var _ref = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee(to, from, next) {
    var hasToken, getUserInfo, isRes, code;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          // start progress bar
          NProgress.start();

          // set page title
          document.title = getPageTitle(to.meta.title);
          // determine whether the user has logged in
          hasToken = getToken();
          if (!hasToken) {
            _context.next = 48;
            break;
          }
          if (!(to.path === "/login")) {
            _context.next = 8;
            break;
          }
          // if is logged in, redirect to the home page
          if (to.params.ga === "1") {
            next();
            NProgress.done();
          } else {
            next({
              path: "/"
            });
            NProgress.done();
          }
          _context.next = 46;
          break;
        case 8:
          if (!(to.path === "/cardholder")) {
            _context.next = 13;
            break;
          }
          next();
          NProgress.done();
          _context.next = 46;
          break;
        case 13:
          if (!store.state.user.gotInfo) {
            _context.next = 18;
            break;
          }
          next();
          NProgress.done();
          _context.next = 46;
          break;
        case 18:
          _context.prev = 18;
          _context.next = 21;
          return getInfo();
        case 21:
          getUserInfo = _context.sent;
          if (!(getUserInfo.result.cust_type === "05")) {
            _context.next = 27;
            break;
          }
          next({
            path: "/cardholder"
          });
          NProgress.done();
          _context.next = 31;
          break;
        case 27:
          _context.next = 29;
          return store.dispatch("user/getInfo");
        case 29:
          next();
          NProgress.done();
        case 31:
          _context.next = 46;
          break;
        case 33:
          _context.prev = 33;
          _context.t0 = _context["catch"](18);
          isRes = _context.t0.response && _context.t0.response.data;
          if (!isRes) {
            _context.next = 42;
            break;
          }
          code = _context.t0.response.data.code;
          if (!(code === codeEnum.noGa)) {
            _context.next = 42;
            break;
          }
          // token expire -> go login page
          next({
            name: "login",
            params: {
              ga: "1"
            }
          });
          NProgress.done();
          return _context.abrupt("return");
        case 42:
          _context.next = 44;
          return store.dispatch("user/resetToken");
        case 44:
          next("/login");
          NProgress.done();
        case 46:
          _context.next = 49;
          break;
        case 48:
          /* has no token*/

          if (whiteList.indexOf(to.path) !== -1) {
            // in the free login whitelist, go directly
            next();
            NProgress.done();
          } else {
            // other pages that do not have permission to access are redirected to the login page.
            next("/login");
            NProgress.done();
          }
        case 49:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[18, 33]]);
  }));
  return function (_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}());
router.afterEach(function () {
  // finish progress bar
  NProgress.done();
});